import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function CtaBand({ title = "Ready to change your culture?", text = "Tell us about your organisation. We'll respond with honest, practical next steps." }) {
  return (
    <section className="relative overflow-hidden border-y border-slate-100 bg-slate-50" data-testid="cta-band">
      <div className="absolute -right-32 -top-32 h-96 w-96 rounded-full bg-teal-light blur-3xl opacity-70" aria-hidden="true" />
      <div className="container-arms relative py-20 lg:py-28">
        <Reveal>
          <p className="eyebrow mb-4">Start the conversation</p>
          <h2 className="max-w-3xl text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-navy">{title}</h2>
          <p className="mt-4 max-w-xl text-base sm:text-lg text-slate-600 leading-relaxed">{text}</p>
          <Link
            to="/contact#enquiry-form"
            data-testid="cta-band-enquire-button"
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-teal px-8 py-4 text-base font-bold text-white transition-all duration-200 hover:scale-[1.03] hover:bg-navy"
          >
            Make an enquiry <ArrowRight size={18} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
